<template>

  <v-row>
        <v-col class="text-left headline font-weight-light">Soluzione soggiorno n. {{data.id}} nel dettaglio</v-col>
        <v-col class="text-right headline font-weight-bold">
        {{data.prezzo/100}} €
        </v-col>


    <v-col cols="12">
        <hr>
    </v-col>

    <v-col cols="12">
      <v-expansion-panels  v-model="panel">
        <v-expansion-panel >
          <v-expansion-panel-header>
            <h3>{{data.titolo}} <editor v-model="data.titolo" :admin="admin" /></h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12">
                <h1 class="text-left headline font-weight-light">{{data.sottotitolo}}<editor v-model="data.sottotitolo" :admin="admin" /></h1>
                <h2 class="text-left body-1 font-weight-light">{{data.descrizione}}<editor v-model="data.descrizione" :admin="admin" /></h2>
              </v-col>
              <v-col cols="12">
                <v-carousel>
                  <v-carousel-item
                    v-for="(item,i) in data.galleria"
                    :key="i"
                    :src="item.src"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>
                <editor-galleria :admin="admin" v-model="data.galleria"/>
              </v-col>
              <v-col cols="12" >
                  <div v-html="data.descrizione_estesa">
                  </div>
                  <editor v-model="data.descrizione_estesa" :admin="admin" htmlenabled="true"/>
              </v-col>
              <template v-for="risorsa in data.risorse" >
              <v-col cols="12" v-for="info in risorsa.info" :key="info.id">
                  <div v-html="info.testo">
                  </div>
                  <editor v-model="info.testo" :admin="admin" htmlenabled="true"/>
              </v-col>
              </template>
            </v-row>
          </v-expansion-panel-content>
          <v-container>
            <v-row>
            <v-col class="text-left body-1 font-weight-bold">Descrizione</v-col>
            <v-col class="text-right text-uppercase body-1 font-weight-bold">Prezzo</v-col>
          </v-row>
        
        <v-row v-for="(item, index) in prezzi" :key="index" >
            <v-col class="text-left body-1 font-weight-light">{{item.descrizione}}<editor v-model="item.descrizione" :admin="admin"></editor></v-col>
            <v-col class="text-right text-uppercase body-1">€ {{(item.importo/100).toFixed(2)}}</v-col>
          </v-row>


          <v-row>
            <v-col class="text-left headline font-weight-light">Prezzo totale</v-col>
            <v-col class="text-right text-uppercase headline font-weight-bold">€ {{data.prezzo/100}}</v-col>
          </v-row>
          </v-container>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>
<script>
import Editor from "@/components/Editor.vue";
import EditorGalleria from "@/components/EditorGalleria.vue";
export default {
  components: {
    Editor,
    EditorGalleria
  },
  props:['data','admin'],
  name: "Soluzione",

  computed:{
      prezzi(){
          var p =[];
          console.log(this.data)
          this.data.risorse.forEach(risorsa => {
              if(risorsa.prezzi){
                p.push(...risorsa.prezzi)
              }

          });
          return p;
      },
      galleria_auto(){
          var p =[];
          console.log(this.data)
          this.data.risorse.forEach(risorsa => {
              if(risorsa.galleria){
                p.push(...risorsa.galleria)
              }
          });
          console.log("galleria",p)
          return p;
      }
  },
  data: () => ({
    panel: 0,
    data:{
      titolo:'titolo soluzione',
      sottotitolo:'sottotitolo soluzione',
      descrizione:'titolo soluzione',
    },
    items: [
      {
        src: "https://www.hotelbernard.it/wp-content/uploads/sites/33/HB_superior_1-4_mod.jpg"
      },
      {
        src: "https://www.hotelbernard.it/wp-content/uploads/sites/33/HB_superior_part2-res.jpg"
      },
      {
        src: "https://www.hotelbernard.it/wp-content/uploads/sites/33/HB_superior_5-1bis-1_mod.jpg"
      },
      {
        src: "https://www.hotelbernard.it/wp-content/uploads/sites/33/HB_superior_4-1-res.jpg"
      }
    ]
  })
};
</script>